import React from 'react'
import CaseOriginComponent from '../../Components/Masters/CaseOrigin/CaseOriginComponent'

function CaseOriginPage() {
    return (
        <CaseOriginComponent/>
    )
}

export default CaseOriginPage